import { AwardsApi } from '../clients';
import { mapCycle } from '../mappers';
import { withNotFoundAs } from './notFound';

/**
 * Reads one cycle for the detail screen.
 *
 * A 404 is a legitimate answer — a deleted or mistyped id — so it resolves to
 * null and the page renders a not-found state. Everything else propagates, so
 * a 403 or 500 surfaces as an error rather than masquerading as not-found.
 */
export const getCycleById = (cycleId) =>
  withNotFoundAs(null, async () => mapCycle(await AwardsApi.getCycle(cycleId)));
